/**
 * "Druk w toku" - pamiec przegladarki o paragonie, ktory wlasnie idzie na drukarke.
 *
 * PO CO: 11.09 (Kalisz, PAR/0155/09/2026/KAL) strona kasy zrestartowala sie
 * 22 s po sprzedazy, w trakcie ok. 10 s miedzy wyslaniem pakietow a
 * potwierdzeniem drukarki. Paragon fizycznie wyszedl, ale potwierdzenie nigdy
 * nie dotarlo do serwera: pos_transakcje.fiskalizacja zostalo 0 i jedyna opcja
 * w UI ("Fiskalizuj") drukowala paragon DRUGI raz.
 *
 * Ten modul NIE dotyka protokolu drukarki ani pakietow XML. Zapisuje tylko
 * w localStorage znacznik "paragon X jest w drukarce" BEZPOSREDNIO PRZED
 * wyslaniem i kasuje go, gdy drukarka odpowie (tak / nie / nie wiadomo, takze
 * wyjatek). Jesli po restarcie strony znacznik wciaz jest, POS pyta kasjera,
 * czy paragon wyszedl - i dopiero czlowiek ustawia status. Nigdy automat.
 *
 * Czysty JS, bez Reacta. Wszystkie operacje na localStorage w try/catch:
 * przegladarka moze rzucic (tryb prywatny, brak miejsca, zablokowane dane).
 */

export const KLUCZ_DRUK_W_TOKU = 'v3sys_druk_w_toku';

/** Po tym czasie wpis jest bezuzyteczny - nikt nie pamieta, co bylo na rolce. */
export const PRZETERMINOWANIE_MS = 24 * 60 * 60 * 1000;

const SCIEZKI = ['finalizacja', 'ponowny'];

const magazyn = () => {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return null;
    return window.localStorage;
  } catch (_) {
    return null;
  }
};

/**
 * Zapisuje znacznik druku w toku. Nadpisuje poprzedni (drukujemy jeden paragon
 * naraz). Zwraca zapisany wpis albo null, gdy dane sa niepelne / zapis sie nie udal.
 *
 * @param {{transactionId:number, numer?:string, kwota?:number|string, sciezka?:string, rozpoczeto?:string}} dane
 */
export function zapiszDrukWToku(dane) {
  try {
    const transactionId = Number(dane && dane.transactionId);
    if (!Number.isInteger(transactionId) || transactionId <= 0) return null;
    const kwotaNum = parseFloat(dane.kwota);
    const wpis = {
      transactionId,
      numer: dane.numer ? String(dane.numer) : null,
      kwota: Number.isFinite(kwotaNum) ? Math.round(kwotaNum * 100) / 100 : null,
      rozpoczeto: dane.rozpoczeto || new Date().toISOString(),
      sciezka: SCIEZKI.includes(dane.sciezka) ? dane.sciezka : 'finalizacja',
    };
    const ls = magazyn();
    if (!ls) return null;
    ls.setItem(KLUCZ_DRUK_W_TOKU, JSON.stringify(wpis));
    return wpis;
  } catch (_) {
    return null;
  }
}

/**
 * Odczytuje wpis. Zwraca null, gdy brak, uszkodzony JSON albo niepelne dane.
 * Uszkodzony wpis jest od razu kasowany, zeby nie straszyl przy kazdym starcie.
 */
export function odczytajDrukWToku() {
  const ls = magazyn();
  if (!ls) return null;
  let surowy;
  try {
    surowy = ls.getItem(KLUCZ_DRUK_W_TOKU);
  } catch (_) {
    return null;
  }
  if (!surowy) return null;
  try {
    const wpis = JSON.parse(surowy);
    const id = Number(wpis && wpis.transactionId);
    if (!wpis || typeof wpis !== 'object' || !Number.isInteger(id) || id <= 0 || !wpis.rozpoczeto) {
      wyczyscDrukWToku();
      return null;
    }
    return {
      transactionId: id,
      numer: wpis.numer ? String(wpis.numer) : null,
      kwota: Number.isFinite(parseFloat(wpis.kwota)) ? parseFloat(wpis.kwota) : null,
      rozpoczeto: String(wpis.rozpoczeto),
      sciezka: SCIEZKI.includes(wpis.sciezka) ? wpis.sciezka : 'finalizacja',
    };
  } catch (_) {
    wyczyscDrukWToku();
    return null;
  }
}

/** Kasuje znacznik. Nigdy nie rzuca. */
export function wyczyscDrukWToku() {
  try {
    const ls = magazyn();
    if (ls) ls.removeItem(KLUCZ_DRUK_W_TOKU);
    return true;
  } catch (_) {
    return false;
  }
}

/**
 * Czy wpis jest starszy niz 24 h (albo ma nieczytelna date)? Taki wpis nalezy
 * zignorowac i wyczyscic - patrz odczytajAktualnyDrukWToku.
 *
 * @param {object|null} wpis
 * @param {Date|number|string} [teraz] - domyslnie new Date()
 */
export function czyPrzeterminowany(wpis, teraz) {
  if (!wpis || !wpis.rozpoczeto) return true;
  const start = new Date(wpis.rozpoczeto).getTime();
  if (!Number.isFinite(start)) return true;
  const t = teraz === undefined ? Date.now() : new Date(teraz).getTime();
  if (!Number.isFinite(t)) return true;
  return (t - start) > PRZETERMINOWANIE_MS;
}

/**
 * Wygodne dla startu POS: wpis nieprzeterminowany albo null. Przeterminowany
 * jest kasowany po drodze.
 */
export function odczytajAktualnyDrukWToku(teraz) {
  const wpis = odczytajDrukWToku();
  if (!wpis) return null;
  if (czyPrzeterminowany(wpis, teraz)) {
    wyczyscDrukWToku();
    return null;
  }
  return wpis;
}
